<div class="cards">
  <ix-scrub-task-card></ix-scrub-task-card>
  <ix-cloudsync-task-card></ix-cloudsync-task-card>
  <ix-snapshot-task-card></ix-snapshot-task-card>
  <ix-rsync-task-card></ix-rsync-task-card>
  <ix-replication-task-card></ix-replication-task-card>
  <ix-smart-task-card></ix-smart-task-card>
</div>
